/* eslint-disable no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import dayjs from 'dayjs';
const lastSunday = dayjs().startOf('week').startOf('day');
const nextSunday = dayjs().endOf('week').startOf('day');

const sixAM = dayjs().set('hour', 6).startOf('hour');
const nineAM = dayjs().set('hour', 9).startOf('hour');

const generalChanges = {
  unsavedData: false,
  validationError: false,
  type: 'onboarding',
  campaignName: 'campaignName campaignName',
  goal: 'acquire new users',
  fromDate: new Date(lastSunday),
  toDate: new Date(nextSunday),
  fromTime: new Date(sixAM),
  toTime: new Date(nineAM),
  // fullCampaignObj: {},
  // fullCampaignObjBackUp: {},
};
const mainCampaignObject = {
  unsavedData: false,
};

const getDefaultState = () => {
  return {
    unsavedData: false,
    validationError: false,
    // generalChanges: generalChanges,
    // fullCampaignObj: {},
    // campaignData: null,
    mainCampaignObject: mainCampaignObject,
    // fullCampaignObjBackUp: null,
    tempSelectedLocations: [],
    selectedRegions: [],
    campaignEnvironment: false,
    minBidIsRelevant: false,
    minBidValue: 0,
    bidErrorMessage: '',
    // isCpmSelected: false,
  };
};

const generalSlice = createSlice({
  name: 'generalSettings',
  initialState: getDefaultState(),
  reducers: {
    setTierField: (state, action) => {
      // console.log({
      //   payload: action.payload,
      //   old: JSON.parse(JSON.stringify(state.mainCampaignObject.currentCampaignObj?.Tier)),
      // });
      if (state.mainCampaignObject.currentCampaignObj.Tier !== action.payload) {
        state.mainCampaignObject.currentCampaignObj.Tier = action.payload;

        if (action.payload) {
          state.minBidIsRelevant = false;
        }
      }
    },
    updateMinBidServerStates: (state, action) => {
      state.minBidValue = action.payload.minBid;
      state.bidErrorMessage = action.payload.errorMsg;
    },
    setMinBidAsRelevant: (state) => {
      state.minBidIsRelevant = true;
    },
    setMinBidAsNotRelevant: (state) => {
      state.minBidIsRelevant = false;
    },
    setDefaultState: (state) => {
      //state = getDefaultState();
      return getDefaultState();
    },
    setCampaignEnvironment: (state, action) => {
      state.campaignEnvironment = action.payload;
    },
    updateProperty: (state, action) => {
      state.generalChanges[action.payload.propField] = action.payload.newValue;
      state.unsavedData = true;
    },
    setCampaignDataForID: (state, action) => {
      const new_mainCampaignObject = structuredClone(action.payload);
      const { target_type, isAllPlacements } = new_mainCampaignObject.currentCampaignObj;
      if (target_type === 1 && !isAllPlacements) {
        new_mainCampaignObject.currentCampaignObj.isAllPlacements = true;
      }
      state.mainCampaignObject = new_mainCampaignObject;
      state.tempSelectedLocations = action.payload?.selected_locations || [];
      const selected_locations = state.tempSelectedLocations;
      if (selected_locations.length > 0) {
        const tiersArray = selected_locations
          .map(({ tier }) => tier)
          .filter((tier) => tier !== undefined && tier !== null);
        const minTier = tiersArray.length > 0 ? Math.min(...tiersArray) : 0;
        if (state.mainCampaignObject.currentCampaignObj) {
          state.mainCampaignObject.currentCampaignObj.Tier = minTier;
        }
      }
      state.unsavedData = false;
    },
    updateCurrentCampaignObj: (state, action) => {
      const { propField, newValue } = action.payload;
      if (propField === 'target_type') {
        state.mainCampaignObject.currentCampaignObj.isAllPlacements = newValue === 1;
      }
      state.mainCampaignObject.currentCampaignObj[action.payload.propField] =
        action.payload.newValue;
      state.unsavedData = true;
    },
    updateSelectedLocations: (state, action) => {
      state.mainCampaignObject.selected_locations = action.payload;
      state.unsavedData = true;
    },
    updateSelectedLocationsForSaving: (state, action) => {
      state.mainCampaignObject.currentCampaignObj.selectedLocationsList = action.payload;
      // state.mainCampaignObject.currentCampaignObj.bid = null;
      // state.mainCampaignObject.currentCampaignObj.bidType = 0;
    },
    // setCampaignDataForIDBackUp: (state, action) => {
    //   state.fullCampaignObjBackUp = action.payload;
    // },
    // updateMainCampaignObject: (state, action) => {
    //   state.mainCampaignObject[action.payload.propField] = action.payload.newValue;
    //   state.unsavedData = true;
    // },
    updateCurrentCampaignGoal: (state, action) => {
      state.mainCampaignObject.currentCampaignObj[action.payload[0].propField] =
        action.payload[0].newValue;
      state.mainCampaignObject.currentCampaignObj[action.payload[1].secondPropField] =
        action.payload[1].secondValue;
      state.unsavedData = true;
    },
    updateTempSelectedLocations: (state, action) => {
      state.tempSelectedLocations = action.payload;
      state.unsavedData = true;
    },
    setSelectedRegions: (state, action) => {
      state.selectedRegions = action.payload;
      state.unsavedData = true;
    },
    update_currently_selected_apps: (state, action) => {
      state.mainCampaignObject.currently_selected_apps = action.payload;
      const new_target_apps_list = action.payload.map(({ pba_number }) => pba_number).join(',');
      state.mainCampaignObject.currentCampaignObj.target_apps_list = new_target_apps_list;
      state.minBidIsRelevant = false;
      state.unsavedData = true;
    },
    delete_currently_selected_app: (state, action) => {
      const victim_pba_number = action.payload;
      const new_state = state.mainCampaignObject.currently_selected_apps.filter(
        (app) => app.pba_number !== victim_pba_number,
      );
      state.mainCampaignObject.currently_selected_apps = new_state;
      const new_target_apps_list = new_state.map(({ pba_number }) => pba_number).join(',');
      state.mainCampaignObject.currentCampaignObj.target_apps_list = new_target_apps_list;
      state.minBidIsRelevant = false;
      state.unsavedData = true;
    },
    clear_currently_selected_apps: (state) => {
      state.mainCampaignObject.currently_selected_apps = [];
      state.mainCampaignObject.currentCampaignObj.target_apps_list = '';
      state.unsavedData = true;
    },
    changeUnsavedData: (state, action) => {
      state.unsavedData = action.payload;
    },
    // inisializeIsCpm: (state, action) => {
    //   state.isCpmSelected = action.payload;
    // },
    // synchronizeIsCpm: (state, action) => {
    //   state.isCpmSelected = action.payload;
    //   state.unsavedData = true;
    // },
    saveNewLocationFilters: (state, action) => {
      state.mainCampaignObject.selected_locations = action.payload;

      const included = action.payload.filter((e) => e.status === 'include');
      const excluded = action.payload.filter((e) => e.status === 'exclude');

      const formatLocation = (element) => {
        if (element.type === 'city') {
          return `${element.id}`;
        } else {
          return `${element.id || element.unq_id}`;
        }
      };

      const includedLocations = included.map(formatLocation);
      const excludedLocations = excluded.map(formatLocation);

      // Remove the last comma from the last element in includedLocations
      const lastIncludedLocation = includedLocations[includedLocations.length - 1];
      includedLocations[includedLocations.length - 1] = lastIncludedLocation?.replace(/,$/, '');

      // Concatenate the strings
      const newListToSave = includedLocations + '|' + excludedLocations;
      if (state.mainCampaignObject) {
        state.mainCampaignObject.currentCampaignObj.selectedLocationsList = newListToSave;
        // state.mainCampaignObject.currentCampaignObj.location = 2;
      }

      state.unsavedData = true;
    },
    resetMainCampaignObject: (state) => {
      state.mainCampaignObject = {
        unsavedData: false,
      };
      state.minBidIsRelevant = false;
    },
    resetCurrentCampaignObject: (state) => {
      //state.mainCampaignObject.currentCampaignObj.isOnBoarding = '';
      state.mainCampaignObject.currentCampaignObj.bidType = 0;
      state.mainCampaignObject.currentCampaignObj.bid = null;
      state.mainCampaignObject.currentCampaignObj.budget = 200;
      state.mainCampaignObject.currentCampaignObj.reEngageGoal = false;
      state.mainCampaignObject.currentCampaignObj.acquireNewUserGoal = true;

      state.mainCampaignObject.currently_selected_apps = [];

      state.mainCampaignObject.currentCampaignObj.target_type = 1;
      state.mainCampaignObject.currentCampaignObj.campaignLangs = '';
      state.mainCampaignObject.currentCampaignObj.brands_audience_to_save = { inc: '', exc: '' };
      state.mainCampaignObject.currentCampaignObj.userAgentsOSType = 1;
      state.mainCampaignObject.currentCampaignObj.userAgentsOSList = '';
      state.mainCampaignObject.currentCampaignObj.userAgentsOSMinVer = 32;
      state.mainCampaignObject.currentCampaignObj.customAudienceObj = '';
      state.mainCampaignObject.selected_locations = [];
      state.mainCampaignObject.currentCampaignObj.location = 2;
      state.mainCampaignObject.currentCampaignObj.selectedLocationsList = '|';
      state.unsavedData = true;
    },
    changeCampaignTypeAction: (state, action) => {
      state.mainCampaignObject.currentCampaignObj.isOnBoarding = action.payload;
      state.mainCampaignObject.currentCampaignObj.bidType = 3;
      state.mainCampaignObject.currentCampaignObj.bid = null;
      state.mainCampaignObject.currentCampaignObj.budget = 200;
      state.mainCampaignObject.currentCampaignObj.reEngageGoal = false;
      state.mainCampaignObject.currentCampaignObj.acquireNewUserGoal = true;

      state.mainCampaignObject.currently_selected_apps = [];

      state.mainCampaignObject.currentCampaignObj.target_type = 1;
      state.mainCampaignObject.currentCampaignObj.campaignLangs = '';
      state.mainCampaignObject.currentCampaignObj.brands_audience_to_save = { inc: '', exc: '' };
      state.mainCampaignObject.currentCampaignObj.userAgentsOSType = 1;
      state.mainCampaignObject.currentCampaignObj.userAgentsOSList = '';
      state.mainCampaignObject.currentCampaignObj.userAgentsOSMinVer = 32;
      state.mainCampaignObject.currentCampaignObj.customAudienceObj = '';

      state.mainCampaignObject.selected_locations = [];
      state.mainCampaignObject.currentCampaignObj.location = 2;
      state.mainCampaignObject.currentCampaignObj.selectedLocationsList = '|';

      state.unsavedData = true;
    },
    // update_target_app_list: (state, action) => {
    //   state.mainCampaignObject.currentCampaignObj.target_apps_list = action.payload;
    // },
  },
});

export const generalActions = generalSlice.actions;
export default generalSlice.reducer;
